import {fork} from 'redux-saga/effects';

import clickId from './clickId';
import identify from './identify';
import track from './trackConversion';

/**
 * Begin of saga.
 */
export default function* impactRadius() {
    yield fork(identify);
    yield fork(clickId);
    yield fork(track);
}
